import React, { Component } from 'react';
import { Nav, NavItem } from 'react-bootstrap';
import NumberUtils from '../../../../utils/NumberUtils';

class ProjectionSettingsCommitments extends Component {
  constructor(props) {
    super(props);

    this.dateConversion = this.dateConversion.bind(this);
    this.getDirectDebits = this.getDirectDebits.bind(this);
    this.getStandingOrders = this.getStandingOrders.bind(this);
    this.handleSelect = this.handleSelect.bind(this);

    this.state = {
      changeContentFlagCommitments: true,
      activeCss1: 'active',
      activeCss2: '',
    };
  }

  dateConversion(value) {
    if (value !== '') {
      const monthName = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];
      const fullDate = new Date(value);
      const day = fullDate.getDate();
      const month = fullDate.getMonth();
      const year = fullDate.getFullYear();
      const dateStr = `${`0${day}`.slice(-2)} ${monthName[month].substr(
        0,
        3
      )} ${year.toString().substr(2, 4)}`;
      return <label>{dateStr}</label>;
    }
  }

  getDirectDebits() {
    let component;
    if (this.props.data !== undefined) {
      if (this.props.data.directDebits !== undefined) {
        component = this.props.data.directDebits.map((rows, index) => {
          return (
            <div
              className="commitments-content"
              key={`ProjectionSettingsCommitments_getDirectDebits_${index}`}
            >
              <section>
                <h5 className="">
                  {this.dateConversion(rows.directDebitsLastKnownDate)}
                </h5>
                <p className="">{rows.directDebitsName}</p>
              </section>
              <section>
                <h5 className="">
                  {NumberUtils.appendCurrency(
                    '{}',
                    rows.directDebitsLastKnownAmount
                  )}
                </h5>
                <p className="">{rows.directDebitsFrequency}</p>
              </section>
            </div>
          );
        });
        return component;
      }
    }
  }

  getStandingOrders() {
    let component;
    if (this.props.data !== undefined) {
      if (this.props.data.commitments !== undefined) {
        component = this.props.data.commitments.map((rows, index) => {
          return (
            <div
              className="commitments-content"
              key={`getStandingOrders_commitments${index}`}
            >
              <section>
                <h5 className="">
                  {this.dateConversion(rows.standingOrderLastKnownDate)}
                </h5>
                <p>{rows.standingOrderName}</p>
              </section>
              <section>
                <h5>
                  {NumberUtils.appendCurrency(
                    '{}',
                    rows.standingOrderLastKnownAmount
                  )}
                </h5>
                <p>{rows.standingOrderFrequency}</p>
              </section>
            </div>
          );
        });
        return component;
      }
    }
  }

  handleSelect(selectedKey) {
    if (selectedKey === 1) {
      this.setState({
        changeContentFlagCommitments: true,
        activeCss1: 'active',
        activeCss2: '',
      });
    } else {
      this.setState({
        changeContentFlagCommitments: false,
        activeCss1: '',
        activeCss2: 'active',
      });
    }
  }

  render() {
    return (
      <div className="full-height">
        <div className="projections-commitments-buttons">
          <Nav
            justified
            activeKey={this.state.activeKey}
            onSelect={this.props.handleSelect}
            bsClass="nav nav-justified tag-nav"
          >
            <NavItem
              eventKey={1}
              href="#ourtags"
              className={this.props.activeCss1}
            >
              Direct Debits
            </NavItem>
            <NavItem
              eventKey={2}
              href="#yourtags"
              className={this.props.activeCss2}
            >
              Standing Orders
            </NavItem>
          </Nav>
        </div>
        <div className="projections-commitments">
          {' '}
          {this.props.changeContentFlagCommitments
            ? this.getDirectDebits()
            : this.getStandingOrders()}{' '}
        </div>
      </div>
    );
  }
}

export { ProjectionSettingsCommitments };
